<template>
  <div class="flex justify-end">
    <!-- <el-dropdow > -->
      <!-- <div class="userInfo">
         <span>您好：{{ name }}</span>
         <span></span>
         <span @click="logout">登出</span>
         <i class="el-icon-caret-bottom el-icon--right text-dark"></i>
      </div> -->
      <!-- <el-dropdown-menu slot="dropdown" :hide-on-click="false">
        <el-dropdown-item command="userCenter">个人中心</el-dropdown-item>
        <el-dropdown-item command="logout">退出登录</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown> -->
    <div class="header-right">
      <el-popover placement="bottom"  width="120" trigger="click">
        <div class="infoList">
          <span @click="isShowGrzx = true">个人中心</span>
          <span @click="isShowXgmm = true">修改密码</span>
        </div>
        <div class="operateItem" slot="reference">
          <img :src="imageUrlprefix+userForm.avatar" alt="">
          <span style="color: white">{{ userForm.name }}</span>
<!--          <img src="@/assets/images/gzq/iconx1.png" alt="">-->
          <i style="color: white;font-size: 14px" class="el-icon-arrow-down"></i>
        </div>
      </el-popover>
      <div class="operateItem operateItemTc" @click="isShowTc = true">
<!--        <img src="@/assets/images/gzq/tc.png" alt="">-->
        <i style="color: white;font-size: 20px" class="el-icon-switch-button"></i>
        <span style="color: white">退出</span>
      </div>
    </div>
    <!-- 个人中心 -->
    <myDialog :isDialog="isShowGrzx" title="个人中心" :isFooter="true" @handleClose="closeGrzx ">
      <template slot="content">
        <div class="passwordList">
          <el-form :model="userForm" ref="userForm" label-width="100px">
            <el-form-item label="登录账号" >
              <el-input v-model="userForm.account" disabled></el-input>
            </el-form-item>
            <el-form-item label="用户姓名" >
              <el-input v-model="userForm.name" ></el-input>
            </el-form-item>
            <el-form-item label="联系方式" >
              <el-input v-model="userForm.phone" maxlength="11"></el-input>
            </el-form-item>
            <el-form-item label="所属部门" >
              <el-input v-model="userForm.bmName" disabled></el-input>
            </el-form-item>
            <el-form-item label="权限角色" >
              <el-input v-model="userForm.roleNames" disabled></el-input>
            </el-form-item>
          </el-form>
        </div>
      </template>
      <template slot="footer">
        <div class="formBtnBox">
          <div class="editBtn"  @click="closeGrzx">取消</div>
          <div class="saveBtn  ml-4" @click="updateInfo">确定</div>
        </div>
      </template>
    </myDialog>
    <!-- 修改密码 -->
    <myDialog :isDialog="isShowXgmm" title="修改密码" :isFooter="true" @handleClose="isShowXgmm = false">
      <template slot="content">
        <div class="passwordList">
          <el-form :model="pwdForm" :rules="rules" ref="pwdForm" label-width="100px">
            <el-form-item label="旧密码"  prop="oldPassword">
              <el-input  show-password v-model="pwdForm.oldPassword" autocomplete="off" placeholder="请输入旧密码" />
            </el-form-item>
            <el-form-item label="新密码" prop="newPassword">
              <el-input  v-model="pwdForm.newPassword" show-password autocomplete="off" placeholder="请输入新密码"/>
            </el-form-item>
            <el-form-item label="确认新密码" prop="addNewPassword">
              <el-input  v-model="pwdForm.addNewPassword" show-password autocomplete="off" placeholder="请确认新密码"/>
            </el-form-item>
          </el-form>
        </div>
      </template>
      <template slot="footer">
        <div class="formBtnBox">
          <div class="editBtn"  @click="isShowXgmm = false,pwdForm = {}">取消</div>
          <div class="saveBtn  ml-4" @click="submitXgmm">确定</div>
        </div>
      </template>
    </myDialog>
    <!-- 退出 -->
    <myDialog :isDialog="isShowTc" title="退出登录" :isFooter="true" @handleClose="isShowTc = false">
      <template slot="content">
        <div class="data">
          <img src="@/assets/images/gzq/tc2.png" alt="">
          <span>确定退出登录？</span>
        </div>
      </template>
      <template slot="footer">
        <div class="formBtnBox">
          <div class="editBtn"  @click="isShowTc = false">取消</div>
          <div class="saveBtn  ml-4" @click="logout">确定</div>
        </div>
      </template>
    </myDialog>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import defaultAvater from "@/assets/defaultAvater.png"
import {changeCurrentPwd, currentInfo,updateCurrentInfo} from "@/api/login";
import {encrypt} from "@/utils/jsencrypt";
export default {
  name: "UserOpt",
  components: {
  },
  computed: {
    ...mapGetters([
      'name',
      'phone',
    ]),
  },
  data () {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.pwdForm.newPassword) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    }
    return {
      defaultAvater,
      isShowXx:false,
      isShowTc:false,
      isShowGrzx:false,
      isShowXgmm:false,
      resData:null,
      messageList:[],
      userForm:{},
      count:0,
      pwdForm:{},
      rules: {
        oldPassword:[
          {require:true,trigger:'blur'}
        ],
        newPassword: [
          {validator: validatePass, trigger: 'blur' }
        ],
        addNewPassword: [
          {validator: validatePass2, trigger: 'blur'}
        ],
      }
    }
  },
  mounted() {
    this.getNum()
    this.getNoticeList()
    this.getInfo()
    // 消息中心已读点击
    // this.$bus.$on("changeReadXx", () => {
      // this.getNum()
      // this.getNoticeList()
    // });
  },
  methods: {
    uploadSuccess(){

    },
    showUploadList(){
      this.$refs.minioUpload.setDialog(true);
    },
    // 获取个人信息
    getInfo(){
      currentInfo({}).then(res=>{
        if(res && res.code == 200 && res.data){
          this.userForm = res.data
        }
      })
    },
    closeGrzx(){
      this.isShowGrzx = false
      this.getInfo()
    },
    // 修改个人信息
    updateInfo(){
      updateCurrentInfo({name:this.userForm.name,phone:this.userForm.phone}).then(res=>{
        if(res && res.code == 200){
          this.getInfo()
          this.$message.success('操作成功！')
          this.isShowGrzx = false
          this.userForm = {}
        }
      })
    },
    // 修改密码
    submitXgmm(){
      if(this.pwdForm.oldPassword == undefined){
        this.$message.error('请输入旧密码!');
        return
      }
      if(this.pwdForm.newPassword == undefined){
        this.$message.error('请输入新密码!');
        return
      }
      if(this.pwdForm.addNewPassword == undefined){
        this.$message.error('请输入确认新密码!');
        return
      }
      if(this.pwdForm.addNewPassword == this.pwdForm.newPassword){
        this.pwdForm.oldPassword = encrypt(this.pwdForm.oldPassword)
        this.pwdForm.newPassword = encrypt(this.pwdForm.newPassword)
      }else{
        this.$message.error('两次密码输入不一致!');
        return
      }
      this.$confirm('是否确认修改密码？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        changeCurrentPwd({oldPassword:this.pwdForm.oldPassword,newPassword:this.pwdForm.newPassword}).then(res=>{
          if(res && res.code == 200){
            this.$message.success('操作成功！')
            this.isShowXgmm = false
            this.pwdForm = {}
          }
        })
      }).catch(() => {
        this.$message.info('已取消!');
      });
    },
    // 点击已读
    // handleRead(item){
    //   this.$confirm('是否确认已读该消息？', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   }).then(() => {
    //     setRead({id:item.id}).then(res=>{
    //       if(res && res.code && res.data){
    //         this.getNoticeList()
    //         this.getNum()
    //         this.$bus.$emit('changeReadXxzxList')
    //         this.$message.success('已读成功!');
    //       }
    //     })
    //   }).catch(() => {
    //     this.$message.info('已取消!');
    //   });
    // },
    // 关闭消息弹框
    closeXxDialog(){
      this.isShowXx = false;
    },
    // 获取未读消息数量
    getNum(){
      // noReadCountMy({}).then(res=>{
      //   if(res && res.code == 200){
      //     this.count = res.data.count
      //   }
      // })
    },
    // 获取消息列表
    getNoticeList(){
      // listMy({state:0}).then(res=>{
      //   if(res && res.code == 200){
      //     this.messageList = res.data
      //   }
      // })
    },
    // 添加保存传参
    recombinationFormData(param, callback) {
      param = {
        ...param,
        comId:this.comId
      }
      callback({ ...param })
    },
    logout() {
      this.$store.dispatch('LogOut').then(() => {
        this.$router.push("/login")
      })
      // remove("visitViews");
      // this.$emit('drawerClose')
    },
    handleCommand(command){
       if(command==="userCenter"){
          this.$router.push("/user/center")
       }
       if(command==="logout"){
         this.$store.dispatch('LogOut').then(() => {
           this.$router.push("/login")
         })
        //  remove("visitViews");
      }
    },
    successAddChange(e) {
      this.$emit('dialogClose')
      this.$message.success('操作成功！')
    },
  }
}
</script>

<style scoped lang="scss">
.userInfo{
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  // color: $mainColor;
  color: #fff;
  font-weight: 400;
  font-size: 14px;
  line-height: 14px;
  cursor: pointer;
  img{
    display: inline-block;
    border-radius: 50%;
  }
  span{
    display: inline-block;
  }
  span:nth-child(2) {
    width: 1px ;
    height: 14px;
    background-color: rgba(0, 0, 0, 0.2);
    margin: 0px 16px;
  }
}
.infoList{
  display: flex;
  flex-direction: column;
  padding: 0px 16px;
  >span{
    width: 100%;
    color: #464d5a;
    font-family: "Alibaba PuHuiTi 3.0";
    font-weight: 400;
    font-size: 13px;
    text-align: center;
    padding:8px 0;
    border-bottom: 1px solid #EDF0F2;
    cursor: pointer;
    &:last-child{
      border: none;
    }
  }
}
.header-right{
  display: flex;
  align-items: center;
  .operateItem{
    display: flex;
    align-items: center;
    // min-width: 120px;
    height: 36px;
    display: flex;
    place-content: center;
    place-items: center;
    cursor: pointer;
    margin-right: 26px;
    >div{
      position: relative;
      >img{
        width: 24px;
        height: 24px;
      }
      >div{
        position: absolute;
        top:-7px;
        right: -7px;
        width: 13px;
        height: 11px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        background: #ff4958;
        color: #ffffff;
        font-family: "Alibaba PuHuiTi 3.0";
        font-weight: 700;
        font-size: 7px;
      }
    }
    >img{
      width: 24px;
      height: 24px;
    }
    >span{
      color: #464D5A;
      font-family: "Alibaba PuHuiTi 3.0";
      font-weight: 400;
      font-size: 14px;
      padding-left: 6px;
    }
  }
  .operateItemTc{
    // width: 80px;
    margin-right: 0;
  }
}
// 退出登录
.data{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  >img{
    width: 200px;
    height: 200px;
  }
  >span{
    text-align: center;
    color: #1c1c1c;
    font-family: "Alibaba PuHuiTi 3.0";
    font-weight: 400;
    letter-spacing: 8px;
    font-size: 18px;
    padding-top: 4px;
  }
}
.msgBox{
  display: flex;
  flex-direction: column;
  height: 100%;
  align-items: center;
}
.messageList{
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  .messageItem{
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 14px;
    width: 100%;
    >img{
      width: 40px ;
      height: 40px;
    }
    .itemRight{
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-left: 16px;
      padding-top: 10px;
      padding-bottom: 16px;
      border-bottom: 1px solid #EDF0F2;
      flex: 1;
      .title{
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-bottom: 10px;
        .bt{
          color: #1c1c1c;
          font-family: "Alibaba PuHuiTi 3.0";
          font-weight: 400;
          font-size: 14px;
        }
        .time{
          color: #464d5a;
          font-family: "Alibaba PuHuiTi 3.0";
          font-weight: 400;
          font-size: 12px;
        }
      }
      >span{
        color: #464d5a;
        font-family: "Alibaba PuHuiTi 3.0";
        font-weight: 400;
        font-size: 12px;
      }
      .btn{
        padding: 3.5px 12px;
        border-radius: 53px;
        background: #ff49581a;
        text-align: right;
        color: #ff4958;
        font-family: "Alibaba PuHuiTi 3.0";
        font-weight: 400;
        font-size: 12px;
        white-space:nowrap;
        cursor: pointer;
      }
    }
  }
}
.fillBtn{
  padding: 0px 12px;
  border-radius: 53px;
  background: #1e6fff1a;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 40px;
  >img{
    width: 16px;
    height: 16px;
  }
  >span{
    color: #1e6fff;
    font-family: "Alibaba PuHuiTi 3.0";
    font-weight: 400;
    font-size: 14px;
    padding-left: 8px;
  }
}
// .myDialog /deep/.el-dialog{
//   height: 600px !important;
// }
.noMore{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 40px;
  >img{
    width: 200px;
    height: 200px;
  }
  >span{
    padding-top: 16px;
    letter-spacing: 4px;
    color: #212223;
    font-family: "Alibaba PuHuiTi 3.0";
    font-weight: bold;
    font-size: 14px;
  }
}
/* 修改垂直滚动条 */
/deep/::-webkit-scrollbar {
  width: 3px; /* 修改宽度 */
}
</style>
